import { useTranslation } from "react-i18next";
import { createSystemBoundaryCategories } from "../../../../../apis/Business/EnergyApi";
import saveIcon from "../../../../../assets/design-revamp-company/system-boundary-subcategory/saveIcon.svg";
import { useUserAccess } from "../../../../../components/WriteAccessContext";
import { createSystemBoundarySubcategory } from "../../../../../apis/Business/InventoryApi";

const SystemBoundary = ({
  systemBoundary,
  setSystemBoundary,
  businessId,
  totalObjCategory,
  customStyles,
  isInventory = false,
  isTransportDelivery,
}) => {
  const { t } = useTranslation();
  const { userAccess } = useUserAccess();

  const handleSave = () => {
    if (!isInventory) {
      createSystemBoundaryCategories({
        businessId: businessId,
        systemBoundaryCategory: systemBoundary,
        categoryName: totalObjCategory,
      });
    } else {
      createSystemBoundarySubcategory({
        businessId: businessId,
        systemBoundarySubcategory: systemBoundary,
        subcategory: totalObjCategory,
      });
    }
  };

  return (
    <div
      className={
        isTransportDelivery
          ? "system-boundary-box-transport"
          : "system-boundary-box"
      }
      style={customStyles}
    >
      <h5 style={{ fontWeight: "bold", marginBottom: "10px" }}>
        {t("SYSTEM_BOUNDARY")}
      </h5>
      <textarea
        value={systemBoundary}
        onChange={(e) => setSystemBoundary(e.target.value)}
        placeholder={t("COMMENT_BOUNDARY")}
        style={{
          border: "1px white solid",
          borderRadius: "5px",
          width: "100%",
        }}
      />
      {userAccess === "write" && (
        <img
          src={saveIcon}
          alt="Save Icon"
          width={20}
          height={20}
          className="sub-icon-save"
          onClick={handleSave}
        />
      )}
    </div>
  );
};

export default SystemBoundary;
